import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';
import {SachetStock} from '../model/sachet-stock.model';
import {ParseObjectUtil} from '../util/parse-object.util';
import {User} from '../model/user.model';
import {SachetAction} from '../model/sachet-action.model';

@Injectable({
    providedIn: 'root'
})
export class SachetStockService {

    constructor(private db: AngularFirestore) {
    }

    findStockByOrganizationCode(code: string) {
        return this.db.collection<SachetStock>('sachets-stock').doc('sachets-stock-615').valueChanges();
    }

    findStockByOrganizationName(code: string) {
        return this.db.collection<SachetStock>('sachets-stock').doc().valueChanges();
    }

    initStock(sachetStock: SachetStock) {
        sachetStock.redCount = 0;
        sachetStock.yellowCount = 0;

        this.db.collection<SachetStock>(`sachet-stock-${sachetStock.code}`).doc(sachetStock.code)
            .set(ParseObjectUtil.parse(sachetStock)).then(savedValue => {
            console.log('successfully', savedValue);
        });


        // return this.db.collection<SachetStock>(`sachet-count-${sachetStock.code}`).doc(sachetStock.code).valueChanges();
    }

    async saveSachetStock(sachetStock: SachetStock) {
        return this.findStockByOrganizationCode(sachetStock.code).subscribe(stock => {
            this.db.collection<SachetStock>('sachets-stock').doc(sachetStock.code).set(ParseObjectUtil.parse(this.updateStock(stock)));
        });
    }

    private updateStock(sachetStock: SachetStock) {
        if (sachetStock?.yellowCount) {
            sachetStock.yellowCount += sachetStock.yellowCount;
        }

        if (sachetStock?.redCount) {
            sachetStock.redCount += sachetStock.redCount;
        }

        return sachetStock;
    }

    verifyStock(user: User) {
        return this.db.collection<SachetStock>(`sachets-stock`).doc(`sachets-stock-${user.organizationModel.id}`).valueChanges();
    }

    save(sachetStock: SachetStock) {
        return this.db.collection<SachetStock>('sachets-stock').doc(sachetStock.code).set(ParseObjectUtil.parse(sachetStock));
    }

    update(sachetStock: SachetStock) {
        return this.db.collection<SachetStock>('sachets-stock').doc(sachetStock.code).set(ParseObjectUtil.parse(sachetStock),
            {merge: true});
    }

    saveAction(sachetAction: SachetAction) {
        return this.db.collection<SachetAction>('sachets-action').doc(sachetAction.token).set(ParseObjectUtil.parse(sachetAction));
    }

    getActionsByOrganizationId(id: string) {
        return this.db.collection<SachetAction>('sachets-action', ref => ref.where('organizationId', '==', id)).valueChanges();
    }

    getSachetsConfig() {
        return this.db.collection<SachetStock>('sachets-management').doc('nSxwmAbpgrt9pAiSP8Ls').valueChanges();
    }

}
